import React from 'react';
import { visuallyHidden } from '@noths/polaris-client-styles';

import { OVERALL_RATING_HEADER } from 'src/components/molecules/ProductRatingMaxiSummary/copy';
import { StarRating } from 'src/components/molecules/StarRating/StarRating';
import type { TextAlignment } from './types';
import * as styles from './OverallProductRating.styles';

interface OverallProductRatingProps {
  alignment: TextAlignment;
  rating: number;
}

export const OverallProductRating = ({ alignment, rating }: OverallProductRatingProps) => {
  return (
    <div
      css={styles.overallRatingContainer}
      style={{ '--alignment': alignment } as styles.RatingBlockCSS}
    >
      <div aria-hidden="true" css={styles.ratingArea}>
        <StarRating productRating={rating} />
        <span css={styles.overallRating} data-testid="rating">
          {rating}
        </span>
        <span css={styles.maximumRating}>/5</span>
        <span css={visuallyHidden}>{rating} out of 5</span>
      </div>
      <h3 css={styles.ratingHeading}>{OVERALL_RATING_HEADER}</h3>
    </div>
  );
};
